module.exports = __webpack_public_path__ + "static/img/background.c5ae1ef5.svg";